<div class="wrapper" ngClass.gt-sm="desktop">
  <div class="container" fxLayout="column" fxFlex>
    <app-header [isFullScreen]="true" [isMenuHidden]="isMenuHidden"></app-header>
    
    <div fxLayout="row" fxLayoutAlign=" stretch" fxFlex style="overflow-x: hidden;">
      <app-root fxFlex></app-root>
    </div>
  </div>
</div>


<mat-menu #mobileMenu="matMenu" [xPosition]="'before'">
  <div mat-menu-item class="mat-menu-header">For students</div>
  <button mat-menu-item [routerLink]="['/','services','student','coupon','ulesson']">Learning discounts</button>
  <button mat-menu-item [routerLink]="['/','user','applications']">Applications</button>
  <hr>
  <div mat-menu-item class="mat-menu-header">For schools</div>
  <button mat-menu-item>Marketing</button>
  <hr>
  <button mat-menu-item [routerLink]="['/','session','log-in']" *ngIf="!isLoggedInStatic">login</button>
  <button mat-menu-item [routerLink]="['/','session','sign-up']" *ngIf="!isLoggedInStatic">sign up</button>
  <button mat-menu-item [routerLink]="['/','user','profile']" *ngIf="isLoggedInStatic">Profile</button>
  <button mat-menu-item (click)="logout()" *ngIf="isLoggedInStatic">Logout</button>
</mat-menu>

<mat-menu #applicationMenu="matMenu" [xPosition]="'before'">
  <button mat-menu-item [routerLink]="['/','user','applications']">view applications</button>
  <button mat-menu-item [routerLink]="['/','user','shortlist']">view shortlist</button>
</mat-menu>

<mat-menu #userMenu="matMenu" [xPosition]="'before'">
  <button mat-menu-item [routerLink]="['/','user','profile']">Profile</button>
  <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<mat-menu #notificationsMenu="matMenu" [xPosition]="'before'">
  <div mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
  <mat-divider></mat-divider>
  <div  mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
  <mat-divider></mat-divider>
  <div  mat-menu-item fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutAlign=" center" fxLayoutGap="16px">
      <div class="school-emblem"></div>
      <div fxFlex>Would you be interested in some skunk?</div>
    </div>
    <div class="notification-time">1:32 PM</div>
  </div>
</mat-menu>